import React from "react";
import "./Source.css";

export default function Source() {
  return (
    <footer>
      {" "}
      <a
        href="https://github.com/leairene/weather-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open sourced code
      </a>{" "}
      by Lea Irene Larssen
    </footer>
  );
}
